import { useScrollLock } from "@/hooks/useScrollLock";
import { Button, Modal } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Disclaimer: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  // 防止移动端滚动穿透
  useScrollLock(visible);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <div
        style={{
          textAlign: "center",
          padding: "20px 0",
          fontSize: "14px",
          color: "#666",
          lineHeight: "1.6",
          borderTop: "1px solid #e5e7eb",
          marginTop: "30px",
        }}
      >
        <p style={{ margin: 0 }}>
          {t("common.disclaimer.report_note")}
          <Button type="link" onClick={showModal} style={{ padding: "0 5px" }}>
            {t("common.disclaimer.view_details_btn")}
          </Button>
        </p>
      </div>

      <Modal
        title={
          <div style={{ textAlign: "center", width: "100%" }}>
            {t("common.disclaimer.title")}
          </div>
        }
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={"90%"}
        centered
      >
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <p>{t("common.disclaimer.thank_you_note")}</p>

          <h3 style={{ fontWeight: "bold", marginTop: "20px" }}>
            {t("common.disclaimer.section1_title")}
          </h3>
          <p>{t("common.disclaimer.section1_content")}</p>

          <h3 style={{ fontWeight: "bold", marginTop: "20px" }}>
            {t("common.disclaimer.section2_title")}
          </h3>
          <p>{t("common.disclaimer.section2_content")}</p>

          <h3 style={{ fontWeight: "bold", marginTop: "20px" }}>
            {t("common.disclaimer.section3_title")}
          </h3>
          <p>{t("common.disclaimer.section3_content")}</p>

          <h3 style={{ fontWeight: "bold", marginTop: "20px" }}>
            {t("common.disclaimer.section4_title")}
          </h3>
          <p>{t("common.disclaimer.section4_content")}</p>
        </div>
      </Modal>
    </>
  );
};

export default Disclaimer;
